import type { FaireProductEntity } from "../../entity_types/product";

export const p_n8djhk6tu7: FaireProductEntity = {
  token: "p_n8djhk6tu7",
  type: "product",
  name: "Ladybugs Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/8dc814b5b74a290f6240fb5f4589be9ad88b8b031d05d819b8777f953d568e4e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4ecaa2a3c003eceb0c8f06a911605c1d662e43ae7e6e679307cd49142cc0c7a6.jpeg",
    "https://cdn.faire.com/fastly/507c704160317eae8cc914eef2f711c32577d1d749f4b49ead76d31837c892ad.jpeg",
    "https://cdn.faire.com/fastly/b5f8070b4a93e3761ad65a65750d3f422495d2a6ee3bbbaf4923c260c2c925f4.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:37.123Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
